import { defineMessages } from 'react-intl';

export default defineMessages({
    R1NoProductCode: {
        id: 'custom.gateway.R1.validationMessages.No product code',
        defaultMessage: 'Effective Date is at least 09/01/2021 for Personal Auto'
    }
});
